import React from "react";
import { faMinusCircle } from "@fortawesome/pro-regular-svg-icons";
import { TurnrFontAwesomeIconButtonRound } from "./TurnrFontAwesomeIconButton";
import { COLORS } from "rylak-common/src/constants";

export default function TurnrMinusIconButton(props) {
    return <TurnrFontAwesomeIconButtonRound color={COLORS.ERROR} icon={faMinusCircle} {...props} />;
}
